module.exports = __webpack_public_path__ + "img/neck_male_mask.9bb1a8b6.png";